import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SignableDoument } from '@core/models/signable-document.model';

export interface EnvelopeState extends EntityState<SignableDoument> {
  signableDocument?: SignableDoument | null;
  error?: {
    status: number;
    message: string;
  } | null;
}

export function createInitialState(): EnvelopeState {
  return {
    signableDocument: null,
    error: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'envelopes', resettable: true })
export class EnvelopeStore extends EntityStore<EnvelopeState> {
  constructor() {
    super(createInitialState());
  }
}
